import { CartAddEvent } from '@theme/events';

(function() {
  'use strict';

  var SAVE_NUDGE_THRESHOLD = 3;
  var ADD_TO_CART_RESET_MS = 2000;

  var REMOVE_BTN_SVG =
    `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2L2 12" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M12 12L2 2" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`;

  function cartAddUrl() {
    if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) {
      return Theme.routes.cart_add_url;
    }
    var shopify = /** @type {{ routes?: { root?: string } }} | undefined} */ (window.Shopify);
    var root = shopify && shopify.routes && shopify.routes.root;
    return (root || '/') + 'cart/add.js';
  }

  /** @param {HTMLElement | null} el @param {number} n */
  function setWishlistCountText(el, n) {
    if (el) el.textContent = '(' + n + ' items)';
  }

  /** @returns {string} Comma-separated section ids, or '' */
  function getCartSectionsCsv() {
    var nodes = document.querySelectorAll('cart-items-component[data-section-id]');
    /** @type {string[]} */
    var ids = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes.item(i);
      if (!node) continue;
      var id = node.getAttribute('data-section-id');
      if (id) ids.push(id);
    }
    return ids.length ? ids.join(',') : '';
  }

  /**
   * @param {any} responseData
   */
  function dispatchCartAddedAndOpenDrawer(responseData) {
    var itemCount =
      responseData && typeof responseData.item_count === 'number' ? responseData.item_count : 0;

    document.dispatchEvent(
      new CartAddEvent(responseData, 'swym-wishlist-page', {
        source: 'swym-wishlist-page',
        itemCount: itemCount,
        sections: (responseData && responseData.sections) || {},
      })
    );

    var cartDrawer = /** @type {any} */ (document.querySelector('cart-drawer-component, cart-drawer'));
    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else if (typeof cartDrawer.showDialog === 'function') {
      cartDrawer.showDialog();
    } else {
      cartDrawer.classList.add('active');
    }
  }

  function showSaveNudge(swat, count) {
    if (swat.platform.isLoggedIn()) return;
    if (count < SAVE_NUDGE_THRESHOLD) return;
    if (sessionStorage.getItem('swym-save-nudge-dismissed')) return;

    var nudge = document.getElementById('swym-save-nudge');
    if (!nudge) return;
    var nudgeEl = nudge;

    var countSpan = document.getElementById('swym-save-nudge-count');
    if (countSpan) countSpan.textContent = String(count);
    nudgeEl.style.display = '';

    var dismiss = document.getElementById('swym-save-nudge-dismiss');
    if (dismiss && !dismiss.hasAttribute('data-swym-dismiss-bound')) {
      dismiss.setAttribute('data-swym-dismiss-bound', '');
      dismiss.addEventListener('click', function() {
        nudgeEl.style.display = 'none';
        sessionStorage.setItem('swym-save-nudge-dismissed', 'true');
      });
    }
  }

  function initWishlistPage(swat) {
    var isLoggedIn = swat.platform.isLoggedIn();
    var grid = document.getElementById('swym-wishlist-grid');
    var loading = document.getElementById('swym-wishlist-loading');
    var empty = document.getElementById('swym-wishlist-empty');
    var countEl = document.getElementById('swym-wishlist-count');

    if (!grid) return;

    if (!isLoggedIn) {
      var loginNudge = document.getElementById('swym-login-nudge');
      if (loginNudge) loginNudge.style.display = '';
    }

    function syncAfterFetch(products) {
      renderProducts(swat, products, grid, countEl, empty);
      setWishlistCountText(countEl, products ? products.length : 0);
    }

    swat.fetch(function(products) {
      if (loading) loading.style.display = 'none';

      if (!products || products.length === 0) {
        if (empty) empty.style.display = 'block';
        setWishlistCountText(countEl, 0);
        return;
      }

      if (empty) empty.style.display = 'none';
      setWishlistCountText(countEl, products.length);
      showSaveNudge(swat, products.length);
      renderProducts(swat, products, grid, countEl, empty);
    });

    if (swat.evtLayer) {
      swat.evtLayer.addEventListener('sw:removedfromwishlist', function() {
        swat.fetch(syncAfterFetch);
      });
    }
  }

  /**
   * @param {any} swat
   * @param {any[] | null | undefined} products
   * @param {HTMLElement | null} container
   * @param {HTMLElement | null} countEl
   * @param {HTMLElement | null} emptyEl
   */
  function renderProducts(swat, products, container, countEl, emptyEl) {
    if (!container) return;

    var cartSectionsCsv = getCartSectionsCsv();

    container.innerHTML = '';

    if (!products || products.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    products.forEach(function(product) {
      var card = document.createElement('div');
      card.className = 'swym-wishlist-card';

      var productUrl = product.du || '#';
      var productTitle = product.dt || 'Product';

      var imgLink = document.createElement('a');
      imgLink.href = productUrl;
      var img = document.createElement('img');
      img.src = product.iu || '';
      img.alt = productTitle;
      img.loading = 'lazy';
      imgLink.appendChild(img);
      card.appendChild(imgLink);

      var titleLink = document.createElement('a');
      titleLink.href = productUrl;
      titleLink.textContent = productTitle;
      card.appendChild(titleLink);

      if (product.pr) {
        var priceEl = document.createElement('span');
        priceEl.textContent = formatPrice(product.pr);
        card.appendChild(priceEl);
      }

      var actions = document.createElement('div');
      actions.className = 'swym-wishlist-card-actions';

      var inStock = product.stk !== 0;
      var cartBtn = document.createElement('button');
      cartBtn.type = 'button';
      cartBtn.classList.add('add-to-cart-button', 'button-secondary', 'swym-btn-add-to-cart');
      cartBtn.textContent = inStock ? 'Add to Cart' : 'Out of Stock';
      cartBtn.disabled = !inStock;

      if (inStock) {
        cartBtn.addEventListener('click', function onAddToCart() {
          /** @type {{ items: { id: number, quantity: number }[], sections_url: string, sections?: string }} */
          var body = {
            items: [{ id: Number(product.epi), quantity: 1 }],
            sections_url: window.location.pathname,
          };
          if (cartSectionsCsv) body.sections = cartSectionsCsv;

          cartBtn.textContent = 'Adding...';
          cartBtn.disabled = true;

          fetch(cartAddUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          })
            .then(function(response) {
              if (!response.ok) throw new Error('Add to cart failed');
              return response.json();
            })
            .then(function(responseData) {
              cartBtn.textContent = 'Added!';
              dispatchCartAddedAndOpenDrawer(responseData);
              window.setTimeout(function() {
                cartBtn.textContent = 'Add to Cart';
                cartBtn.disabled = false;
              }, ADD_TO_CART_RESET_MS);
            })
            .catch(function() {
              cartBtn.textContent = 'Error';
              cartBtn.disabled = false;
            });
        });
      }

      actions.appendChild(cartBtn);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.classList.add('swym-remove-item');
      removeBtn.innerHTML = REMOVE_BTN_SVG;
      removeBtn.setAttribute('aria-label', 'Remove from wishlist');
      removeBtn.addEventListener('click', function() {
        swat.removeFromWishList(
          { epi: product.epi, empi: product.empi, du: product.du },
          function() {
            card.remove();
            var remaining = container.querySelectorAll('.swym-wishlist-card').length;
            setWishlistCountText(countEl, remaining);
            if (remaining === 0 && emptyEl) emptyEl.style.display = 'block';
          }
        );
      });
      actions.appendChild(removeBtn);

      card.appendChild(actions);
      container.appendChild(card);
    });
  }

  /** @param {number} priceInCents */
  function formatPrice(priceInCents) {
    return '$' + priceInCents.toFixed(2);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(initWishlistPage);
})();
